import React, { type FC } from 'react';
import { ClickEventNameEnum } from '@/app/components/search/Curiosity/Analytics/utils/ClickEventNameEnum';
import ArrowIcon from '@/app/components/search/components/Form/children/Container/ArrowIcon';
import type { ClickParams } from '@/app/components/search/Curiosity/Analytics/utils';
import { useTranslation } from '@/app/components/translations/Translation';
import { NavArrowStyled } from './styled';

export type NavArrowProps = {
  direction?: string;
  setMonth: React.Dispatch<React.SetStateAction<number>>;
  setYear: React.Dispatch<React.SetStateAction<number>>;
  firstMonth: {
    month: number;
    year: number;
  };
  eventCallback: (payload: ClickParams) => void;
};

const NavArrow: FC<NavArrowProps> = (props) => {
  const {
    eventCallback,
    direction,
    setMonth,
    setYear,
    firstMonth: { month, year },
  } = props;
  const { t } = useTranslation();
  const date = new Date(year, month);
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth();
  const hide =
    direction === 'left'
      ? currentMonth === month && year === currentYear
      : currentMonth === month + 1 && year !== currentYear;
  const className = direction === 'left' ? 'nav-left' : 'nav-right';

  const handleClick = (): void => {
    const next = new Date(date.setMonth(date.getMonth() + 1));
    const prev = new Date(date.setMonth(date.getMonth() - 2));

    eventCallback({
      event_name:
        direction === 'left'
          ? ClickEventNameEnum.SearchwidgetCalendarPrevMonth
          : ClickEventNameEnum.SearchwidgetCalendarNextMonth,
      event_subcontext: 'button',
      event_value: `${direction === 'left' ? prev.getFullYear() : next.getFullYear()}-${
        direction === 'left' ? prev.getMonth() : next.getMonth()
      }`,
    });

    setMonth(direction === 'left' ? prev.getMonth() : next.getMonth());
    setYear(direction === 'left' ? prev.getFullYear() : next.getFullYear());
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>): void => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleClick();
    }
  };

  return (
    <NavArrowStyled
      hide={hide}
      direction={direction}
      className={className}
      onClick={(): void => handleClick()}
      onKeyDown={(e): void => handleKeyDown(e)}
      role="button"
      tabIndex={0}
      aria-label={
        direction === 'left' ? t('vacation.oss.pagination.previous_page') : t('vacation.oss.pagination.next_page')
      }
    >
      <ArrowIcon />
    </NavArrowStyled>
  );
};

export default NavArrow;
